// extracted by mini-css-extract-plugin
export var content = "logos-block-module--content--858b7 text-content-module--wrapper--bdd0a";
export var img = "logos-block-module--img--85a3b";
export var list = "logos-block-module--list--9f283";